import DataRow from "../../views/ActionPlan/Components/DataRow";
import {DataRowSubType, DataRowType, MultiChoiceDisplayType} from "../enums/enums";
import {IDataRow} from "../interfaces/document";

const NewTextField = (subType: DataRowSubType, id = Math.random() + "", isClosed = false) => (
    {
        id,
        checklistFormDataRowTypeSymbol: DataRowType.TEXT_FIELD,
        header: "", textValue: "", subType,
        isNew: true,
        isClosed: isClosed
    } as IDataRow
)

const NewDescriptionField = (subType: DataRowSubType, isClosed = false) => (
    {
        checklistFormDataRowTypeSymbol: DataRowType.TEXT_FIELD,
        header: "",
        textValue: "",
        subType,
        isNew: true,
        isClosed: isClosed
    } as IDataRow
)

const NewMultiChoice = (subType: DataRowSubType, choices: string[], id = Math.random() + "", isDropdown = false) => (
    {
        id,
        checklistFormDataRowTypeSymbol: DataRowType.MULTI_CHOICE_FIELD,
        multiChoiceValue: choices[0],
        multiChoiceAlternatives: choices.map(v => ({name: v})),
        multiChoiceDisplayType: isDropdown ? MultiChoiceDisplayType.DROPDOWN : MultiChoiceDisplayType.RADIO,
        header: "",
        subType,
        isClosed: false,
        isNew: true
    } as IDataRow
)

const NewActionUser = () => (
    {
        id: Math.random() + "",
        actionUserId: '',
        actionDate: '',
        checklistFormDataRowTypeSymbol: DataRowType.ACTION_PLAN_FIELD,
        header: 'Ansvarig för åtgärd',
        isNew: true,
        isClosed: false,
        subType: DataRowSubType.NONE,
    } as IDataRow
)

const NewDateField = (subType = DataRowSubType.NONE) => (
    {
        checklistFormDataRowTypeSymbol: DataRowType.DATE_FIELD,
        date: null,
        header: '',
        subType,
        isNew: true,
        isClosed: false
    } as IDataRow
)

const NewMultiUserField = (subType: DataRowSubType) => (
    {
        multiUsers: [],
        checklistFormDataRowTypeSymbol: DataRowType.MULTI_USER_FIELD,
        header: "Personer (egna företaget)",
        subType,
        isNew: true,
        isClosed: false
    } as IDataRow
)

const NewMultiPickField = (subType: DataRowSubType, picks: string[]) => (
    {
        checklistFormDataRowTypeSymbol: DataRowType.MULTI_PICK_FIELD,
        header: "",
        isNew: true,
        subType,
        isClosed: false,
        multiPicks: picks.map(v => ({value: v, chosen: false})),
    } as IDataRow
)

const NewImageField = (subType: DataRowSubType) => (
    {
        checklistFormDataRowTypeSymbol: DataRowType.IMAGE_FIELD,
        header: "",
        subType,
        isNew: true,
        isClosed: false,

    } as IDataRow
)

const NewFileField = (subType: DataRowSubType) => (
    {
        checklistFormDataRowTypeSymbol: DataRowType.FILES_FIELD,
        header: "",
        subType,
        isNew: true,
        isClosed: false,
        files: [],
        newFiles: []

    } as IDataRow
)


const enum Internal_Ids {
    EXTERNAL_USER_TOGGLE = "External_User_Toggle",
    EXTERNAL_USER_TEXT = "External_Users_Text"
}

/**
 *         NewMultiChoice("Antal sjukdagar på grund av händelsen", ['Ej angivet', '0', '1-2', "3-6", '7-9', '10+']),
 *         NewMultiChoice("Behövdes läkavård/psykolog på grund av händelsen?", ['Ej angivet', 'Ja', 'Nej']),
 *         NewMultiPickField("Rapporterat till", ["Närmsta chef", "Skyddsombud", "Arbetsmiljöverket", "Försäkringskassan"]),
 */
const IncidentDataRows = [
    NewMultiChoice(DataRowSubType.INCIDENT_TYPE, ['Tillbud', 'Olycka', 'Avvikelse']),
    NewDateField(DataRowSubType.INCIDENT_DATE),
    NewTextField(DataRowSubType.INCIDENT_LOCATION),
    NewTextField(DataRowSubType.INCIDENT_DESCRIPTION),
    NewTextField(DataRowSubType.INCIDENT_INSTANT_ACTION),
    NewMultiUserField(DataRowSubType.INCIDENT_USERS),
    NewMultiChoice(DataRowSubType.INCIDENT_EXTERNAL_PERSONAL_EXISTS, ['Ej angivet', 'Ja', 'Nej'], Internal_Ids.EXTERNAL_USER_TOGGLE),
    NewTextField(DataRowSubType.INCIDENT_EXTERNAL_PERSONAL, Internal_Ids.EXTERNAL_USER_TEXT, true),
    NewImageField(DataRowSubType.ACTIONPLAN_SUBTYPE_IMAGE),
    NewFileField(DataRowSubType.INCIDENT_FILES),
    NewActionUser(),
];

const DeviationDataRows = [
    NewMultiChoice(DataRowSubType.INCIDENT_TYPE, ['Tillbud', 'Olycka', 'Avvikelse']),
    NewMultiChoice(DataRowSubType.DERIVATION_TYPE, [
        'Ej angivet',
        'Arbetsmiljö',
        'Kvalitet',
        'Miljö',
        'Förbättringsförslag',
        'Revision',
        'Synpunkt',
        'Kundreklamation',
        'Bristfällande egenkontroller arbetsplats',
        'Bristfällande säkerhet arbetsplats',
        'Bristfällande kemikaliehantering',
        'Bristfällande ekonomisk uppföljning',
        'Resursbrist',
        'Bristfällande kunskap/kompetens',
        'Övrigt'
    ], "", true),
    NewTextField(DataRowSubType.DERIVATION_DESCRIPTION),
    NewTextField(DataRowSubType.DERIVATION_INSTANT_ACTION),
    NewMultiUserField(DataRowSubType.INCIDENT_USERS),
    NewImageField(DataRowSubType.ACTIONPLAN_SUBTYPE_IMAGE),
    NewFileField(DataRowSubType.INCIDENT_FILES),

    NewActionUser(),
];

const StandaloneActionDataRows = [
    NewMultiChoice(DataRowSubType.STANDALONE_CATEGORY, ['Ej angivet', 'Risk', 'Avvikelse', 'Tillbud/olycka', 'Förbättringsförslag'], Math.random() + "", true),
    NewTextField(DataRowSubType.STANDALONE_DESCRIPTION),
    NewTextField(DataRowSubType.STANDALONE_ACTION),
    NewTextField(DataRowSubType.STANDALONE_RESOURCES),
    NewActionUser(),
];
/**
 *    NewMultiChoice(DataRowSubType.INCIDENT_TYPE, ['Tillbud', 'Olycka', 'Avvikelse']),
 *     NewMultiChoice("Typ av avvikelse", ['Ej angivet', 'Arbetsmiljö', 'Kvalitet', 'Miljö', 'Förbättringsförslag', 'Revision', 'Synpunkt', 'Kundreklamation', 'Övrigt'], "", true),
 *     //NewMultiChoice("Kund/leverantör/internt", ['Tillbud', 'Olycka', 'Avvikelse']),
 *     NewTextField("Beskrivning"),
 *     NewTextField("Bidragande orsaker"),
 *     NewMultiUserField("Personer (egna företaget)"),
 *     NewActionUser(),
 */

const getDataRowHeader = (dataRow: IDataRow): string => {
    if (dataRow.subType == null) return dataRow.header;
    const subHeader = SubTypeToHeader[dataRow.subType!] ?? ''
    return subHeader.length > 0 ? subHeader : dataRow.header;
}
const SubTypeToHeader: Record<DataRowSubType, string> = {

    [DataRowSubType.NONE]: "",
    [DataRowSubType.INCIDENT_LOCATION]: "Plats för händelsen",
    [DataRowSubType.INCIDENT_DESCRIPTION]: "Beskrivning av händelse/situation",
    [DataRowSubType.INCIDENT_CAUSE]: "Orsak",
    [DataRowSubType.INCIDENT_TYPE]: "Typ",
    [DataRowSubType.INCIDENT_EXTERNAL_PERSONAL]: "Ytterligare information angående externa personer",
    [DataRowSubType.INCIDENT_EXTERNAL_PERSONAL_EXISTS]: "Fanns det externa personer involverade",
    [DataRowSubType.INCIDENT_USERS]: "Personer (egna företaget)",
    [DataRowSubType.INCIDENT_DATE]: "Datum för händelsen",
    [DataRowSubType.INCIDENT_ROOT_CAUSE]: "Grundorsak",
    [DataRowSubType.INCIDENT_LONGTERM_ACTION]: "Långsiktig åtgärd",
    [DataRowSubType.INCIDENT_FOLLOW_UP]: "Uppföljning",
    [DataRowSubType.INCIDENT_SICKDAYS]: "Antal sjukdagar pga händelsen",
    [DataRowSubType.INCIDENT_MEDICAL_ASSISTANCE]: "Behövdes läkarvård/psykolog på grund av händelsen",
    [DataRowSubType.INCIDENT_REPORTED_TO]: "Rapporterat till",
    [DataRowSubType.INCIDENT_HEAD_DESCRIPTION]: "Kort beskrivning av ärende",
    [DataRowSubType.INCIDENT_IMAGE]: "Bild",
    [DataRowSubType.INCIDENT_FILES]: "Filer",
    [DataRowSubType.INCIDENT_INSTANT_ACTION]: "Direkt åtgärd",
    [DataRowSubType.INCIDENT_ACTION]: "Åtgärd",

    [DataRowSubType.DERIVATION_INSTANT_ACTION]: "Direkt åtgärd",
    [DataRowSubType.DERIVATION_CAUSE]: "Bidragande orsaker",
    [DataRowSubType.DERIVATION_DESCRIPTION]: "Beskrivning",
    [DataRowSubType.DERIVATION_TYPE]: "Typ av avvikelse",
    [DataRowSubType.DERIVATION_LONGSHORTTERM_ACTION] : "Kort/långsiktig åtgärd",

    [DataRowSubType.STANDALONE_CATEGORY]: "Kategori",
    [DataRowSubType.STANDALONE_DESCRIPTION]: "Beskrivning situation/händelse",
    [DataRowSubType.STANDALONE_ACTION]: "Åtgärd",
    [DataRowSubType.STANDALONE_RESOURCES]: "Tid, pengar, kompetens",
    [DataRowSubType.STANDALONE_INSTANT_ACTION]: "Direktåtgärd",

    [DataRowSubType.ACTIONPLAN_SUBTYPE_IMAGE]: "Bild",
    [DataRowSubType.ACTIONPLAN_SUBTYPE_FILES]: "Filer",

    [DataRowSubType.COMMON_MULTIPLE_USER]: "Personer (egna företaget)",
};

export {
    Internal_Ids,
    NewTextField,
    NewDescriptionField,
    NewMultiPickField,
    NewMultiChoice,
    NewMultiUserField,
    NewActionUser,
    NewDateField,
    NewImageField,
    IncidentDataRows,
    DeviationDataRows,
    StandaloneActionDataRows,
    DataRowType,
    MultiChoiceDisplayType,
    getDataRowHeader
};

